import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SparklesIcon, BookOpenIcon, MapIcon, KeyRoundIcon, ZapIcon, HeadphonesIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  title: 'Manual Maestro de Abundancia',
  desc: 'Guía de Intervención Neuro-Biológica de 60 páginas + Audios de Meditación 888Hz incluidos.',
  value: '$47'
}, {
  icon: MapIcon,
  title: 'BONO #1: The Flow Map 888',
  desc: 'Tu GPS diario de riqueza y alineación.',
  value: '$20'
}, {
  icon: KeyRoundIcon,
  title: 'BONO #2: La Llave Maestra del Oro Líquido',
  desc: '33 Decretos de Poder para abrir flujos bloqueados.',
  value: '$17'
}, {
  icon: ZapIcon,
  title: 'BONO #3: Protocolo de Manifestación Acelerada',
  desc: 'Técnicas de colapso de tiempo (72 horas).',
  value: '$13'
}];
interface HoyTeLlevasSectionProps {
  handlePurchase: () => void;
}
export function HoyTeLlevasSection({
  handlePurchase
}: HoyTeLlevasSectionProps) {
  return <section aria-label="Hoy te llevas todo esto" className="py-16 sm:py-24 px-4 sm:px-[5%] relative border-t border-white/5 bg-cover bg-center" style={{
    backgroundImage: "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Simbolo_dorado_infinito_en_el_vacio.png?v=1775971771&width=1200&crop=center')"
  }} data-id="element-163">
      {/* Overlay — same effect as CienciaSection */}
      <div className="absolute inset-0" aria-hidden="true" style={{
      background: 'linear-gradient(180deg, #0A0A0B 5%, rgba(10,10,11,0.7) 50%, #0A0A0B 95%)',
      zIndex: 1
    }} data-id="element-164" />
      <div className="absolute inset-0 hidden lg:block" aria-hidden="true" style={{
      background: 'linear-gradient(90deg, #0A0A0B 15%, transparent 60%, #0A0A0B 95%)',
      zIndex: 1
    }} data-id="element-165" />
      <div className="max-w-[800px] mx-auto relative" style={{
      zIndex: 2
    }} data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-167">
          <span className="inline-flex items-center gap-2 bg-gold/10 text-gold px-5 py-2 rounded-full text-[10px] sm:text-xs font-extrabold tracking-[2px] uppercase mb-6" data-id="element-168">
            <GiftIcon className="w-4 h-4" data-id="element-169" />
            OFERTA ESPECIAL
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black leading-tight" data-id="element-170">
            HOY TE LLEVAS <span className="text-gold" data-id="element-171">TODO ESTO</span>
          </h2>
          <p className="text-white/70 text-base sm:text-lg mt-4 max-w-xl mx-auto" data-id="element-172">
            Un sistema completo de reprogramación neuro-cuántica por una
            fracción de su valor real.
          </p>
        </motion.div>

        <div className="space-y-3 sm:space-y-4 mb-10" data-id="element-173">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center gap-4 p-4 sm:p-5 rounded-xl bg-white/[0.03] border border-gold/10" data-id="element-174">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gold/10 flex items-center justify-center shrink-0" data-id="element-175">
                <item.icon className="w-5 h-5 sm:w-6 sm:h-6 text-gold" data-id="element-176" />
              </div>
              <div className="flex-1 min-w-0 text-center" data-id="element-177">
                <h3 className="text-white font-bold text-sm sm:text-base leading-snug" data-id="element-178">
                  {item.title}
                </h3>
                <p className="text-white/50 text-[11px] sm:text-xs mt-0.5 leading-relaxed" data-id="element-179">
                  {item.desc}
                </p>
              </div>
              <span className="text-white/25 text-xs sm:text-sm line-through shrink-0 font-bold" data-id="element-180">
                {item.value}
              </span>
            </motion.div>)}
        </div>

        {/* Audio highlight */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.4,
        delay: 0.5
      }} className="flex items-center justify-center gap-3 mb-10 py-3 px-5 rounded-lg bg-gold/5 border border-gold/15 max-w-md mx-auto" data-id="element-181">
          <HeadphonesIcon className="w-5 h-5 text-gold shrink-0" data-id="element-182" />
          <p className="text-gold/80 text-xs sm:text-sm font-semibold text-center" data-id="element-183">
            Incluye audios de meditación guiada a 888Hz
          </p>
        </motion.div>

        {/* Total + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center" data-id="element-184">
          <div className="inline-flex flex-col items-center bg-white/5 border border-gold/20 rounded-2xl px-8 py-6 sm:px-12 sm:py-8 mb-8" data-id="element-185">
            <div className="flex items-center gap-3 mb-2" data-id="element-186">
              <span className="text-white/40 text-sm line-through" data-id="element-187">
                Valor Total: $97
              </span>
              <span className="bg-red-500/20 text-red-400 text-[10px] font-black px-2 py-0.5 rounded uppercase" data-id="element-188">
                -86%
              </span>
            </div>
            <div className="flex items-baseline gap-2" data-id="element-189">
              <span className="text-gold text-5xl sm:text-6xl font-black" data-id="element-190">
                $14
              </span>
              <span className="text-white/50 text-sm" data-id="element-191">pago único</span>
            </div>
          </div>

          <div data-id="element-192">
            <button onClick={handlePurchase} className="inline-flex items-center justify-center bg-gold text-dark py-4 sm:py-5 px-8 sm:px-10 text-base sm:text-lg font-black rounded-xl shadow-[0_15px_35px_rgba(212,175,55,0.3)] hover:scale-[1.03] hover:bg-[#f1c40f] transition-all uppercase tracking-wide cursor-pointer border-none" data-id="element-193">
              <SparklesIcon className="w-5 h-5 mr-2 -mt-0.5" data-id="element-194" />
              QUIERO ACTIVAR MI CÓDIGO
            </button>
            <div className="mt-4 flex flex-col items-center gap-1.5 text-[10px] sm:text-[11px] font-bold tracking-[1.5px] text-gold/60" data-id="element-195">
              <p data-id="element-196">🔒 Pago 100% seguro con PayPal y tarjeta</p>
              <p data-id="element-197">⚡ Acceso inmediato después de tu compra</p>
              <p data-id="element-198">✅ Garantía de devolución de 30 días sin preguntas</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}